import { styled } from '@nykaa/ui-components';
import RenderIfVisible from 'shared/components/RenderIfVisible';

export const Container = styled.div`
  width: 100%;
  padding: 16px 8px;
`;

export const ProductGrid = styled(RenderIfVisible)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: 0 8px;
`;

export const ProductCard = styled.a<{ isSelected?: boolean }>`
  width: calc(50% - 8px);
  margin-bottom: 16px;
  text-decoration: none;
  display: block;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 6px;
  padding: 6px;
  
  ${({ isSelected, theme }) => isSelected && `
    box-shadow: 0 0 0 2px ${theme.colors.primary}, 0 4px 8px rgba(0, 0, 0, 0.15);
    background-color: ${theme.colors.surface10};
    transform: translateY(-2px);
  `}
  
  &:active {
    transform: scale(0.98);
  }
`;

export const SelectedProductIndicator = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  
  &:before {
    content: '✓';
    font-size: 12px;
    font-weight: bold;
  }
`;

export const ProductImage = styled.img`
  width: 100%;
  aspect-ratio: 1.33;
  object-fit: cover;
  border-radius: 4px;
`;

export const ProductInfo = styled.div`
  padding: 8px 0;
`;

export const ProductTitle = styled.h3`
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProductSubtitle = styled.p`
  font-size: 11px;
  margin: 2px 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
`;

export const DiscountedPrice = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const OriginalPrice = styled.span`
  font-size: 11px;
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-left: 4px;
`;

export const DiscountPercent = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.success};
  margin-left: 4px;
`;

export const LoadingIndicator = styled.div`
  text-align: center;
  padding: 16px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &:before {
    content: '';
    width: 16px;
    height: 16px;
    border: 2px solid ${({ theme }) => theme.colors.surface20};
    border-top: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    margin-right: 8px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const NoData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 100%;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const ImageContainer = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.surface10};
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const SearchImage = styled.img`
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 12px;
`;

export const InspirationTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 12px 0 8px;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: 0 16px;
`;

export const InspirationText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 12px;
  line-height: 1.4;
  padding: 0 16px;
`;

export const CategoryTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  margin: 12px 0 8px;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: 0 16px;
`;

export const AccessoryChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding: 0 16px;
`;

export const AccessoryChip = styled.div`
  padding: 4px 10px;
  background-color: ${({ theme }) => theme.colors.surface20};
  border-radius: 16px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.textPrimary};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }
`;